import styled from 'styled-components'

export const SignInOut = styled.div`
    width: 950px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto;
`